export default ({
  pageState: { editorBlocks },
  data: { blockIds, editor, expirationDate, updatedAt }
}) => {
  return {
    editorBlocks: {
      ...editorBlocks,
      ...blockIds.reduce((blocks, id) => {
        blocks[id] = {
          ...editorBlocks[id],
          data: {
            ...JSON.parse(JSON.stringify(editorBlocks[id].data)),
            markAsNewUntil: expirationDate
          },
          editor,
          isEdited: true,
          updatedAt
        };
        return blocks;
      }, {})
    },
    editorHeaderStatus: 'saved',
    editorHeaderUpdatedAt: updatedAt,
    editorIsDraft: true
  }; 
};
